import { Component, computed, input } from '@angular/core';
import { computeFillPercent } from '../v3-scores-overview/score-fill';

// Desktop's mini-card version of V3ScoreBar's mobile row. See v3-scores-overview/CLAUDE.md.
@Component({
  selector: 'app-v3-score-card',
  imports: [],
  standalone: true,
  templateUrl: './v3-score-card.html',
  styleUrl: './v3-score-card.scss',
})
export class V3ScoreCard {
  readonly label = input.required<string>();
  readonly value = input.required<number>();
  readonly max = input.required<number>();
  /** V3 score-tier CSS custom property name (e.g. '--v3-score-good'). */
  readonly colorVar = input.required<string>();
  readonly isRatingSuspended = input(false);

  readonly fillPercent = computed(() =>
    computeFillPercent(this.value(), this.max(), this.isRatingSuspended()),
  );
}
